import React from 'react'
import { formatDate } from '../../../shared/constants'
import StatusTable from '../StatusTable'

export default function EmployeeStatus() {
  const tableData = (item, tableHeadings) => {
    let tempData = []
    tableHeadings && tableHeadings.map((val) => tempData.push({ value: item[val] }))
    return tempData
    // return [
    //   { value: item.employeeCode },
    //   { value: item.firstName },
    //   { value: item.lastName },
    //   { value: item.phoneNumber },
    //   { value: item.employeeType },
    //   { value: formatDate(item.dob) },
    //   { value: item.email },
    //   { value: item.password },
    //   { value: item.rank },
    //   { value: item.positionCode },
    //   { value: item.reportingManagerCode },
    //   { value: formatDate(item.joiningDate) },
    //   { value: item.address },
    //   { value: item.regionCode },
    //   { value: item.zoneCode },
    //   { value: item.stateCode },
    //   { value: item.districtCode },
    //   { value: item.cityCode },
    //   { value: item.storeCode },
    //   { value: item.remark ? item.remark : '-----' },
    //   { type: 'STATUS_ENUM', status: item.status },
    // ]
  }

  return <StatusTable key="Employee" tableData={tableData} module="EMPLOYEE" />
}
